import React from 'react';

//

function _makeCallable(value) {
  return typeof value === 'function' ? value : () => value;
}

// Exports
// -------

export default function useDocumentTitle(title) {
  React.useEffect(() => {
    if (!title) {
      return;
    }

    const pageTitle = _makeCallable(title)();

    window.document.title = `${pageTitle ? `${pageTitle} | Learning Lab` : ''}`;
  }, [title]);
}
